import axios from 'axios'
import barramento from "@/barramento"

import logger from "@/utils/logger"

// Request Interceptor
axios.interceptors.request.use(
    config => {
        const method = config.method.toUpperCase();
        const url = config.url;
        logger.debug(`[Axios Request] ${method} ${url}`);
        return config;
    },
    error => {
        logger.error(`[Axios Request Error] ${error.message}`);
        return Promise.reject(error);
    }
);

const success = res => {
    const method = res.config ? res.config.method.toUpperCase() : 'UNKNOWN';
    const url = res.config ? res.config.url : 'UNKNOWN';
    const status = res.status;
    logger.debug(`[Axios Response] ${method} ${url} - Status: ${status}`);
    return res;
}

const error = err => {
    // Log detalhado do erro de requisição
    const method = err.config ? err.config.method.toUpperCase() : 'UNKNOWN';
    const url = err.config ? err.config.url : 'UNKNOWN';
    const status = err.response ? err.response.status : 'NO_RESPONSE';

    // Log warn for 4xx, error for others
    if (status >= 400 && status < 500) {
        logger.warn(`[Axios Error] ${method} ${url} - Status: ${status} - Message: ${err.message}`);
    } else {
        logger.error(`[Axios Error] ${method} ${url} - Status: ${status} - Message: ${err.message}`);
    }

    if (err.response && 401 === err.response.status) {
        barramento.enviarStatusLogin(true, true)
    } else {
        return Promise.reject(err)
    }
}

axios.interceptors.response.use(success, error)